.add-to-cart-button {
  display: block;
  width: 100%;
}